module.exports = __webpack_public_path__ + "img/KH-注册1.a3723a3b.png";